//reducer is where state goes
// action dispatch to reducer
//e.g. getItems dispatch to reducer
// send response (state) from server to reducer

import {
  MEETING_MINUTES_NOTIFICATION,
  MEETING_MINUTES_REMOVE_REPORT,
} from "../actions/types";

const initialState = {
  notification: "",
  submittedReports: [],
};

//will later get state from api

export default function (state = initialState, action) {
  let submittedReports = state.submittedReports;
  switch (action.type) {
    case MEETING_MINUTES_NOTIFICATION:
      console.log("currrrrititititem acicic", action.payload);
      if (action.payload?.resp?.data) {
        submittedReports.push(action.payload.resp.data.id);
        console.log("currrrrititititem new subbmitt", submittedReports);
      }
      return {
        ...state,
        notification: action.payload.msg,
        submittedReports,
      };
    case MEETING_MINUTES_REMOVE_REPORT:
      console.log("currrrrititititem removv", action.payload);
      if (action.payload) {
        submittedReports = submittedReports.filter((x) => x !== action.payload);
        console.log("currrrrititititem new subbmitt", submittedReports);
      }
      return {
        ...state,
        submittedReports,
      };
    default:
      return state;
  }
}
